/**
 * API Configuration for Admin Panel
 * Matches the structure from the existing web app
 */

/** Dev API — staging backend (api-staging.versusapp.com). */
const DEV_API_CLOUDFRONT = 'https://api-staging.versusapp.com';

const getApiBaseURL = (): string => {
  // Priority 1: Explicit API URL from environment variable
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Priority 2: Environment type (local, dev, prod)
  const env = process.env.REACT_APP_ENV || 'dev';
  
  switch (env) {
    case 'local':
      return 'http://localhost:3000';
    case 'dev':
      return DEV_API_CLOUDFRONT;
    case 'prod':
      return 'https://api.versusapp.com';
    default:
      return DEV_API_CLOUDFRONT;
  }
};

export const API_CONFIG = {
  baseURL: getApiBaseURL(),
  defaultVerificationCode: (process.env.REACT_APP_ENV === 'local' || process.env.REACT_APP_ENV === 'dev') ? '123456' : '',
};

/**
 * Live Admin Control endpoints (backend ships in parallel from versusapp).
 * Paths are kept HERE — and only here — so a backend contract drift is a
 * one-line fix. Do not inline these strings in apiService methods.
 */
export const LIVE_CONTROL_ENDPOINTS = {
  /** GET → { version:int, config:{...} } · PUT body = config JSON → saves, version++ */
  appConfig: '/api/v1/admin/app-config',
  /** PUT body = { items: [{ id, displayOrder, pinned, featured, dashboardRank? }] } → { updated, missing } */
  marketsOrdering: '/api/v1/admin/markets/ordering',
  /** POST multipart field "file" → { url } (promo/push images) */
  promoUpload: '/api/v1/admin/uploads/promo',
} as const;
